import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { RcsProvider } from './components';

const routes = () => (
  <PrivateRoute exact path="/settings/rcs-provider" component={RcsProvider} />
);
export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/RcsProvider/routes.js